import * as types from '../costants/ActionTypes'


export const setResultData = data => ({
  type: types.SET_RESULT_DATA,
  data
});

